<template>
    <div class="monitor-records-container">
        <div class="monitor-records-container__filter">
            <div class="filter-left">
                <v-date-picker
                    v-model="timeRange"
                    :max-date="0"
                    :shortcuts="shortcuts"
                    enable-timer
                    :placeholder="$t('请选择时间段')"
                    :timer-config="{
                        hasSecond: true
                    }"
                    display-format="YYYY-MM-DD HH:mm:ss"
                    model-format="YYYY-MM-DD HH:mm:ss"
                    @change="datePickerChangeHandler"
                />
                <v-select name="ruleSelect" :options="ruleOptions" :maps="ruleSelectMaps" multiple @change="handleRule" @visibleChange="visibleChangeHandler" />
                <select-input
                    v-model="sensitiveWordsSelected"
                    :options="sensitiveWordsOptions"
                    :multiple="true"
                    :allow-create="false"
                    :placeholder="$t('请选择敏感词')"
                    class="sensitiveWords-selectInput"
                    @search="handleSensitiveWordsSearch"
                >
                    <template #item="{ item }">
                        <span class="tag-item">{{ item.text }}</span>
                    </template>
                </select-input>
            </div>
            <div class="filter-right">
                <v-icon v-tip:tipsRef.hover.delay name="basic_help_line" remote />
                <v-tip ref="tipsRef">
                    {{ $t('点击导出当前筛选后的监控记录数据') }}
                </v-tip>
                <v-button type="button" icon="basic_share_line" remote @click.stop="handlerExports">
                    {{ $t('导出') }}
                </v-button>
            </div>
        </div>
        <dic class="monitor-records-container__table">
            <!-- vhtml逻辑：table组件分页拉取后台数据，需要设置auto是false，要不然分页后不展示数据 -->
            <v-table
                :data="recordsData"
                :header-fix="true"
                :loading="loading"
                class="records-table"
                :auto="false"
                :pagination="pagination"
                @paginationChange="paginationChange"
            >
                <v-table-column
                    v-for="column in recordsColumns"
                    :key="column.columnKey"
                    :column-key="column.columnKey"
                    :label="$t(column.label)"
                    :class="column.class"
                    :width="column.width"
                    :render="column.render"
                />
                <template slot="nodata">
                    <div class="nodata">
                        <img src="../../assets//nodata.png">
                        <span>{{ $t('暂无监控记录') }}</span>
                    </div>
                </template>
            </v-table>
        </dic>
    </div>
</template>
<script>
import Moment from 'moment';
import { envDomain } from 'src/utils/domainConfig';
import SelectInput from '@/components/select-input/SelectInput.vue';
import { recordsColumns, monitorMsgType, degreeConfig } from './config.js';

const endTime = Moment().startOf('day');
const weekStartTime = Moment().startOf('day')
    .subtract(6, 'days');
const mouthStartTime = Moment().startOf('day')
    .subtract(29, 'days');

export default {
    name: 'MonitorRecordsContainer',
    components: {
        SelectInput,
    },
    props: {
        currentSensitiveWords: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            shortcuts: [
                {
                    text: this.$t('全部'),
                    value: [],
                },
                {
                    text: this.$t('最近一周'),
                    value: [weekStartTime, endTime],
                },
                {
                    text: this.$t('最近一个月'),
                    value: [mouthStartTime, endTime],
                },
            ],
            timeRange: [],
            startTime: null,
            endTime: null,
            currentSelect: [],
            isSameRuleWithBefore: false,
            sensitiveWordsSelected: [],
            sensitiveWordsOptions: [],
            ruleOptions: [],
            ruleSelected: [],
            ruleSelectMaps: {
                value: 'id',
                text: 'name',
            },
            loading: false,
            monitorMsgType,
            degreeConfig,
            recordsColumns,
            recordsData: [],
            pagination: {
                index: 1,
                count: 15,
                showQuick: true,
            },
        };
    },
    computed: {
        interfaceParams() {
            let filters = [];
            if (this.sensitiveWordsSelected?.length || this.ruleSelected?.length) {
                const sensitiveWords = {
                    key: 1,
                    values: this.sensitiveWordsSelected,
                };
                const ruleSelected = {
                    key: 2,
                    values: this.ruleSelected,
                };
                if (this.sensitiveWordsSelected?.length) {
                    filters = [sensitiveWords];
                }
                if (this.ruleSelected?.length) {
                    filters.push(ruleSelected);
                }
            }
            const params = {
                pagination: {
                    page_index: this.pagination.index,
                    page_size: this.pagination.count,
                },
                ...(this.startTime && { start_time: this.startTime }),
                ...(this.endTime && { end_time: this.endTime }),
                ...(filters?.length && { filters }),
            };
            return params;
        },
    },
    watch: {
        currentSensitiveWords: {
            handler(val) {
                if (val) {
                    this.sensitiveWordsSelected = [val];
                    this.lastValue = JSON.parse(JSON.stringify(this.sensitiveWordsSelected));
                    this.getMonitorRecordsList();
                }
            },
            immediate: true,
        },
    },
    mounted() {
        this.getSensitiveWordsRuleOptions();
        this.getMonitorRecordsList();
    },
    methods: {
        getSensitiveWordsRuleOptions() {
            this.$ajax.gatewayPost('/tp/sensitiveWords/getList', {
                index: 1,
                count: 5000, // 后台数据量小，协商后传5000，后台放开限制，一次性全拉回
            })
                .then((res) => {
                        const { message = '' } = res;
                        if (res.r !== 0) {
                            this.$message.error(message || this.$t('请求敏感词和规则选项失败，请刷新重试'));
                            return;
                        }
                        const wordList = Array.from(new Set(res.data.map(x => x.wordList)));
                        const wordConcatList = [];
                        wordList.forEach(arr => wordConcatList.push(...arr));
                        Array.from(new Set(wordConcatList)).forEach((item) => {
                            this.sensitiveWordsOptions.push({
                                text: item,
                                value: item,
                            });
                        });
                        res.data.forEach((list) => {
                            this.ruleOptions.push({
                                id: list.id,
                                name: list.name,
                            });
                        });
                    })
                .catch((err) => {
                    this.$message.error(err);
                });
        },
        getMonitorRecordsList() {
            this.loading = true;
            this.$ajax.gatewayPost('/v1/sensitiveWords/getMatchingRecords', this.interfaceParams)
                .then((res) => {
                    this.loading = false;
                    const { message = '' } = res;
                    if (res.code !== 0) {
                        this.$message.error(message || this.$t('请求列表失败，请刷新重试'));
                        return;
                    }
                    this.$set(this, 'recordsData', res.data.records);
                    this.$set(this.pagination, 'total', res.data.pagination.total);
                })
                .catch((err) => {
                    this.$message.error(err);
                });
        },
        datePickerChangeHandler(val) {
            if (val && val.length > 1) {
                this.startTime = Moment(val[0]).unix();
                this.endTime = Moment(val[1]).unix();
            } else {
                this.startTime = undefined;
                this.endTime = undefined;
            }
            this.getMonitorRecordsList();
        },
        paginationChange(pageNum, pageSize) {
            this.$set(this.pagination, 'index', pageNum);
            this.$set(this.pagination, 'count', pageSize);
            this.getMonitorRecordsList();
        },
        isArrayEqualUnordered(arr1, arr2) {
            if ((arr1 && !arr2) || (!arr1 && arr2)) {
                return false;
            }
            return arr1?.length === arr2?.length
                && new Set(arr1).size === arr1.length
                && new Set(arr2).size === arr2.length
                && arr1.every(v => arr2.includes(v));
        },
        visibleChangeHandler(val) {
            if (!val) {
                if (!this.isArrayEqualUnordered(this.currentSelect, this.ruleSelected)) {
                    this.ruleSelected = JSON.parse(JSON.stringify(this.currentSelect));
                    this.getMonitorRecordsList();
                }
            }
        },
        handleRule(value) {
            this.currentSelect = value;
        },
        handleSensitiveWordsSearch(value) {
            if (this.isArrayEqualUnordered(this.lastValue, value)) return;
            this.lastValue = JSON.parse(JSON.stringify(value));
            this.sensitiveWordsSelected = value;
            this.getMonitorRecordsList();
        },
        bytesToBase64(bytes) {
            const binString = Array.from(bytes, byte => String.fromCodePoint(byte)).join('');
            return btoa(binString);
        },
        handlerExports() {
            let { origin } = window.location;
            if (!origin) {
                origin = `${window.location.protocol}//${window.location.hostname}${
                    window.location.port ? `:${window.location.port}` : ''
                }`;
            }
            // 转换为 base64 编码
            const query = this.bytesToBase64(new TextEncoder().encode(JSON.stringify(this.interfaceParams)));
            document.location = `${envDomain.gateway}/v1/sensitiveWords/exportMatchingRecords?query=${query}`;
        },
    },
};
</script>
<style lang="less" scoped>
@import './index.less';
</style>
<style lang="less">
.v-select__popper{
    .v-select__options.v-select-list{
        // overflow-y: hidden;
        ul{
            max-height: initial !important;
            overflow-y: hidden;
        }
    }
}
</style>
